<div>
	<div class="header">
		<div class="title" *ngIf="title">
			<h3>{{title}}</h3>
		</div>
		<div style="display: flex;">
			<form [formGroup]="inputDateForm" style="display: flex;">
				<mat-form-field appearance="outline" class="table-filter" appearance="outline" style="margin-right: 15px; ">
					<mat-label>Choose a date</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="input_date">
					<mat-hint>MM/DD/YYYY</mat-hint>
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
				<button mat-raised-button color="primary" (click)="getBalance()">Submit</button>
			</form>
		</div>
	</div>
	<div>
		<table class="styled-table">
			<caption>Loan Group Transfer Accrued Interest</caption>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th class="amount">Accrued Interest</th>
					<th>Date</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Complete MFT</td>
					<td class="amount"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(completeMft, 'CAD', 'symbol-narrow')}}</div></td>
					<td>{{inputDateForm.controls.input_date.value | date: 'longDate'}}</td>
				</tr>
				<tr>
					<td>Interest ECL</td>
					<td class="amount"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(interestEcl, 'CAD', 'symbol-narrow')}}</div></td>
					<td>{{inputDateForm.controls.input_date.value | date: 'longDate'}}</td>
				</tr>
				<tr *ngFor="let transfer of transfers">
					<td>{{transfer.loan_group_desc}}</td>
					<td class="amount"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(transfer.interest_balance, 'CAD', 'symbol-narrow')}}</div></td>
					<td>{{transfer.transfer_date | date: 'longDate': 'UTC'}}</td>
				</tr>
				<tr class="subtotal">
					<td>Removed Amount</td>
					<td class="amount"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(removedAmount, 'CAD', 'symbol-narrow')}}</div></td>
					<td>&nbsp;</td>
				</tr>
				<tr>
					<td>Net Accrual for this Month</td>
					<td class="amount total"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(netAccrualForThisMonth, 'CAD', 'symbol-narrow')}}</div></td>
					<td>{{inputDateForm.controls.input_date.value | date: 'longDate'}}</td>
				</tr>
				<tr>
					<td>Total Net Accrual</td>
					<td class="amount total"><div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(net, 'CAD', 'symbol-narrow')}}</div></td>
					<td>{{inputDateForm.controls.input_date.value | date: 'longDate'}}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Reusable Skeleton Templates -->
	<ng-template #skeleton>
		<ngx-skeleton-loader count="1" appearance="line"
			[theme]="{ height: '20px', width: '140px', margin: '0' }"></ngx-skeleton-loader>
	</ng-template>
</div>
